<template>
    <section class="section-outline" v-if="!hideHistory() && getPriceHistory && getPriceHistory.length">
        <mvtCollapse :disable="disableCollapse" :isActive="isActive">
            <template v-slot:header="collapsible">
                <h2 class="f2 text-bold">{{molang('dpp.propertyHistory.history')}} <sub class="sub">for {{dpp.geo.address}}</sub></h2>
                <div class="f5 text-gray" v-if="description" v-show="collapsible.collapsed">{{ description }}</div>
            </template>
            <template v-slot:default>
                <ul class="property-history">
                    <template v-for="item in historyData" :key="item.dateMonthYear">
                        <li class="title">
                            <b>{{ item.dateMonthYear }} </b>
                            <div v-if="!item?.history?.[0].isRental">
                                <img v-if="mlsLogoSrc(item?.history?.[0].mlsId) && shouldShowHistoryLogo()" alt="mls logo" loading="lazy" :src="mlsLogoSrc(item?.history?.[0].mlsId)" />
                                <span class="text-gray" v-if="!dpp.showAsPR">MLS # {{ item?.history?.[0].mlsNumber }}</span>
                            </div>
                        </li>
                        <li class="desc" v-for="record in item.history" :key="record.dateDesktop">
                            <span>{{ record.dateDesktop || '—' }}</span>
                            <span>{{ record.status }}</span>
                            <template v-if="record.status === 'Sold' && dpp.hidePropertyPrice">—</template>
                            <template v-else>
                                <div>
                                    <span>{{ record.priceDesktop || '—' }}<template v-if="record.isRental">/Mo</template></span>
                                    <span :class="getClass(record.priceChangeTag)" v-if="record.change != '—'">({{ record.change }})</span>
                                </div>
                            </template>
                        </li>
                    </template>
                </ul>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-history.js"></script>

<style lang="scss">
@use './property-history.scss' as *;
</style>
